export default __webpack_public_path__ + "static/media/advanced-card-image.c2abe1a7.png";